// export this package's api
import createForm from './createForm';
import createFormField from './createFormField';
import formShape from './propTypes';

export { createFormField, formShape, createForm };


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-form/es/index.js
// module id = 85
// module chunks = 0